export function getRole() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return user.role || 'VIEWER';
}

export function getUsername() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return user.username || '';
}

export const isAdmin = () => getRole() === 'ADMIN';
export const isAgent = () => ['ADMIN', 'AGENT', 'DEVELOPER'].includes(getRole());
